var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Debug } from '../../utils/Debug';
import { P4Move } from './P4Move';
let P4MoveGenerator = class P4MoveGenerator extends MoveGenerator {
    getListMoves(node, config) {
        const state = node.gameState;
        const width = state.getWidth();
        const virtualCX = Math.floor((width - 1) / 2);
        return this.getUnorderedListMoves(node, config)
            .sort((left, right) => {
            const distanceFromCenterLeft = Math.abs(left.x - virtualCX);
            const distanceFromCenterRight = Math.abs(right.x - virtualCX);
            return distanceFromCenterLeft - distanceFromCenterRight;
        });
    }
    getUnorderedListMoves(node, _config) {
        // should be called only if the game is not over
        const state = node.gameState;
        const moves = [];
        for (let x = 0; x < state.getWidth(); x++) {
            if (state.getPieceAtXY(x, 0).isNone()) {
                const move = P4Move.of(x);
                moves.push(move);
            }
        }
        return moves;
    }
};
P4MoveGenerator = __decorate([
    Debug.log
], P4MoveGenerator);
export { P4MoveGenerator };
